import type { UsableProp } from '../../shared/game/story-types.js';

/** Last Light's tower stands at (-252, 194) in `ember-coast-places.ts`, its door to the south. */
export const LAST_LIGHT = { id: 'last-light', x: -252, z: 194 };

/** The Ember Coast props heroes can use; each map prop drawing one carries its `id`. */
export const emberCoastUsableProps: UsableProp[] = [
  // Used from the foot of the tower's steps. Tamsin Hale keeps the lamp burning every night (docs/lore/ember-coast-pitch.md).
  { id: LAST_LIGHT.id, name: 'Last Light', x: LAST_LIGHT.x, z: LAST_LIGHT.z + 5.6, radius: .8, reach: 1.5, initial: 'lit',
    states: [{ id: 'lit', lit: true }, { id: 'dark' }],
    uses: [
      { from: 'lit', to: 'dark', label: 'Douse the lamp', announce: 'climbs Last Light and douses the lamp', setsFlags: ['last-light-doused'] },
      { from: 'dark', to: 'lit', label: 'Light the lamp', announce: 'climbs Last Light and lights the lamp', setsFlags: ['last-light-relit'] },
    ] },
];
